import { ReactComponent as IconFilter } from "@/assets/svgs/icon-adjustments-horizontal.svg";
import iconSearch from "@/assets/svgs/icon-search.svg";
import Button from "@/components/Button/index";
import Input from "@/components/Input/index";
import Popover from "@/components/Popover";
import PropTypes from "prop-types";
import { useCallback, useEffect, useRef, useState } from "react";
import FilterRow from "../FilterRow/index";
import { feature } from "@/utils/feature-verifier";
import { featureConstant } from "@/constants/configuration/feature";
import  Search from '@/componentsDS/Search/index'
const Filter = ({
	filter,
	setFilter,
	showSearchInput,
	customFilterHeader,
	inputWidth = 300,
	filterOptions = [
		// {
		// 	key: 'userRole',
		// 	type: 'multiSelect',
		// 	label: 'User Role',
		// 	placeHolderText: 'Select User Role',
		// 	options: [
		// 		{ id: 'SUPER_ADMIN', label: 'Super Admin', value: 'superAdmin' },
		// 		{ id: 'ADMIN_USER', label: 'Admin User', value: 'adminUser' },
		// 		{ id: 'OPERATION_USER', label: 'Operation User', value: 'operationUser' },
		// 		{ id: 'TECH_USER', label: 'Tech User', value: 'techUser' },
		// 	],
		// },
		// {
		// 	key: 'makerCheckerRole',
		// 	type: 'multiSelect',
		// 	label: 'Maker / Checker',
		// 	placeHolderText: 'Select Maker / Checker',
		// 	options: [
		// 		{ id: 'MAKER', label: 'Maker', value: 'maker' },
		// 		{ id: 'CHECKER', label: 'Checker', value: 'checker' },
		// 	],
		// },
		// {
		// 	key: 'date',
		// 	type: 'dateRange',
		// 	label: 'Date Created',
		// 	placeHolderText: ['Start Date', 'End Date'],
		// }
	],
	actions,
	"data-testid": dataTestId,
}) => {
	const [visible, setVisible] = useState(false)
	const [preFilter, setPreFilter] = useState(filter);
	const ref = useRef(null)

	useEffect(() => {
		document.addEventListener('mousedown', handleDocumentClick)
		return () => {
			document.removeEventListener('mousedown', handleDocumentClick)
		}
	}, [])

	useEffect(() => {
		setPreFilter(filter)
	}, [filter])

	function handleDocumentClick(event) {
		if (!ref.current) {
			return
		}

		if (ref.current.contains(event.target)) {
			return
		}
		setVisible(false)
		setPreFilter(filter)
	}

	const handleSearchOnChange = useCallback((e) => {
		setFilter({
			...filter,
			'search': e.target.value,
		})
		return e;
	}, [filter]);
	const handleCancel =  ()=>{
		setFilter({
			...filter,
			'search': '',
		})
	}

	return (
		<div
			className="data-table3__table__head__row primary"
		>
			<div className="left">
				<Popover
					visible={visible}
					options={{ modifiers: [{ name: 'offset', options: { offset: [0, 10] } }] }}
				>
					<Popover.Trigger>
						<div className="data_table__filter_row">
							{
								feature(featureConstant.NEW_DESIGN_SYSTEM) && showSearchInput ? (
									<Search value={filter?.search}  onChange={handleSearchOnChange} onCancel={handleCancel} />
								) :
									(
										<>
											{showSearchInput && (
												<Input
													key="search"
													data-testid={`${dataTestId}-search`}
													placeholder="Search"
													style={{
														backgroundImage: `url(${iconSearch})`,
														width: inputWidth,
													}}
													value={filter?.search}
													onChange={handleSearchOnChange}
													className="data-table__table__search"
												/>
											)}
										</>
									)

							}
							<div
								className={`data_table__filter_icon ${visible ? 'data_table__filter_icon__active' : ''}`}
								data-testid={`${dataTestId}-more-filter-icon`}
								tabIndex={0}
								onClick={() => setVisible(!visible)}
								onKeyDown={() => setVisible(!visible)}
							>
								<IconFilter />
							</div>
						</div>
					</Popover.Trigger>
					<Popover.Content>
						<div ref={ref} className="data_table__filter__popover">
							<div className="filter__header">
								{customFilterHeader ?? <span className="filter__title">
									Filter
								</span>}
							</div>
							<div className="filter__body">
								{filterOptions.map((filter) =>
									<FilterRow
										key={filter?.key}
										data-testid={`${dataTestId}-row`}
										ref={ref}
										filter={filter}
										preFilter={preFilter}
										setPreFilter={setPreFilter}
									/>
								)}
							</div>
							<div className="filter__footer">
								<Button
									maxWidth={75}
									data-testid={`${dataTestId}-reset`}
									ghost
									noborder
									text="Reset"
									submit={() => {
										const keeyOnlySearchFilter = {
											search: preFilter.search ?? null
										}
										setPreFilter(keeyOnlySearchFilter)
										setFilter(keeyOnlySearchFilter)
									}}
								/>
								<Button
									maxWidth={75}
									data-testid={`${dataTestId}-apply`}
									full
									round
									text="Apply"
									submit={() => {
										setFilter(preFilter)
										setVisible(false)
									}}
								/>
							</div>
						</div>
					</Popover.Content>
				</Popover>
			</div >
			<div className="right">
				<div>
					{actions}
				</div>
			</div>
		</div>
	)

};

Filter.propTypes = {
	filter: PropTypes.objectOf(
		PropTypes.shape({
			search: PropTypes.string,
		})
	).isRequired,
	setFilter: PropTypes.func.isRequired,
	showSearchInput: PropTypes.bool,
	customFilterHeader: PropTypes.node,
	inputWidth: PropTypes.number,
	filterOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			type: PropTypes.oneOf(['multiSelect', 'dateRange']).isRequired,
			label: PropTypes.string.isRequired,
			placeHolderText: PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.arrayOf(PropTypes.string),
			]).isRequired,
			options: PropTypes.arrayOf(
				PropTypes.shape({
					id: PropTypes.string.isRequired,
					label: PropTypes.string.isRequired,
					value: PropTypes.string.isRequired,
				})
			),
		})
	),
	actions: PropTypes.node,
	"data-testid": PropTypes.string,
};

export default Filter;
